<div>
  <span *ngIf="message" class="message">{{ message }} </span>
  <div class="loader"></div>
</div>
